/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ReactGA from "react-ga";
import Map3D from "./Map3D";
import FormController from "../../../../../../components/FormController/FormController";
import FormTitle from "../../../../../../components/FormTitle/FormTitle";
import { API_URL } from "../../../../../../config";
import GroupPriceRange from "./GroupPriceRange.js";
import {
  setGroupNumOfTickets,
  setPricingTier,
  setMainSections,
} from "../../../../../../features/singleGroup/singleGroupSlice";
import store from "../../../../../../store";

// import PageLanding from "@/components/PageLanding";
import classes from "./GroupSelectYourSeat.module.scss";

const GroupSelectYourSeat = () => {
  const history = useHistory();
  const { type, groupNumOfTickets, pricingTier, groupGameSelected } =
    useSelector((state) => state?.singleGroup);
  const [seatsInfo, setSeatsInfo] = useState();
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [loaderShow, setLoaderShow] = useState(true);
  const [numOfTickets, setNumOfTickets] = useState(groupNumOfTickets);
  const numOfTicketsRef = useRef(groupNumOfTickets);
  const seatInfoRef = useRef(null);
  const toggleSubmit = (isDisable) => {
    setDisableSubmit(isDisable);
  };
  const tierBasedPrice = (priceFrom) => {
    const priceMapping = { 1: 41319, 2: 41320, 3: 41321 };
    return priceFrom?.[priceMapping?.[pricingTier?.tier]];
  };
  const fetchAvailableSeatsHandler = () => {
    // if (!groupGameSelected?.eventId) history.push("/");
    if (!groupGameSelected?.eventId) return;
    // const ticketsQuantity = store.getState().singleGroup.groupNumOfTickets;
    setLoaderShow(true);
    axios
      .post(`${API_URL}/getEventAvailability`, {
        eventId: groupGameSelected?.eventId,
        // q: ticketsQuantity < 33 ? ticketsQuantity : 33,
        // q: store.getState().singleGroup.groupNumOfTickets,
        q: 1,
      })
      .then((response) => {
        setTimeout(() => {
          setLoaderShow(false);
        }, 1200);
        if (response.data.status !== "error") {
          // show section if has the low tier price
          const _seatInfo = response.data?.info.filter((s) =>
            s.pricesFrom.hasOwnProperty("41319")
          );

          setSeatsInfo(_seatInfo);
          store.dispatch(setMainSections(_seatInfo));
        } else {
          console.log("error", response.data.message);
        }
      })
      .catch((error) => {
        setLoaderShow(false);
        console.log("error", error);
      });
  };
  const between = (x, min, max) => {
    return x >= min && x <= max;
  };
  const NumberOfTicketClickHandler = () => {
    if (!groupGameSelected?.eventId) {
      return;
    }
    // return;
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      html: <GroupPriceRange parentSetNumTickets={setNumOfTickets} />,
      width: 1000,
      showCancelButton: true,
      confirmButtonColor: "#ba0c2f",
      confirmButtonText: "Find my seats",
      cancelButtonText: "cancel",
      allowOutsideClick: false,
      preConfirm: () => {
        // console.log("numOfTickets.current", numOfTickets.current);
        if (!numOfTickets) {
          Swal.showValidationMessage(`Please enter the number of tickets`);
          return;
        }
        return numOfTickets;
      },
    }).then((result) => {
      if (result.isConfirmed) {
        // console.log("result", numOfTicketsRef.current);
        store.dispatch(setGroupNumOfTickets(numOfTicketsRef.current));
        if (between(numOfTicketsRef.current, 20, 99)) {
          store.dispatch(setPricingTier({ tier: 1, tierName: "20-99" }));
        } else if (between(numOfTicketsRef.current, 100, 499)) {
          store.dispatch(setPricingTier({ tier: 2, tierName: "100-499" }));
        } else if (between(numOfTicketsRef.current, 500, 750)) {
          store.dispatch(setPricingTier({ tier: 3, tierName: "500+" }));
        }
        // const ticketsQuantity = store.getState().singleGroup.groupNumOfTickets;

        // if (prevNumOfTicketsRef === ticketsQuantity) return;
        fetchAvailableSeatsHandler();
      }
    });
  };
  const openChatPopUp = () => {
    window.chatBtn();
    if (window.adobeAnalytics && window.adobeAnalytics.tl) {
      window.adobeAnalytics.tl(
        true,
        "o",
        "Washington Nationals: Tickets: Nationals Ticketfinder: Select your seats",
        {
          prop12: "navigation",
          prop13:
            "Washington Nationals: Tickets: Nationals Ticketfinder: Select your seats",
          prop14: `chat with a representative click`,
          evar140: "Chat Now",
        }
      );
    }
  };

  useEffect(() => {
    numOfTicketsRef.current = numOfTickets;
  }, [numOfTickets]);

  useEffect(() => {
    if (!type || !groupGameSelected) history.push("/");
    ReactGA.pageview("/ticket-single-group/group-select-your-seats");

    fetchAvailableSeatsHandler();
    return () => {
      // store.dispatch(setGroupNumOfTickets(99));
    };
  }, []);
  useEffect(() => {
    seatInfoRef.current = seatsInfo?.filter((s) => {
      return tierBasedPrice(s.pricesFrom);
    });
  }, [seatsInfo]);

  return (
    <div>
      <FormTitle title="Select Your Seats" />
      <div className={classes.subTitle}>
        *A $10 processing fee will be added to all Orders at checkout
      </div>
      <div className={classes.FormSelectYourSeat}>
        <Map3D
          seatsInfo={seatInfoRef.current}
          history={history}
          parentClasses={classes}
          toggleSubmit={toggleSubmit}
          // NumberOfTicketClickHandler={NumberOfTicketClickHandler}
          loaderShow={loaderShow}
        />
        <div className={classes.thirdCol}>
          <div
            className={classes.differentPlan}
            // onClick={NumberOfTicketClickHandler}
          >
            <div className={classes.smallTitle}>
              Interested in a Luxury Suite?
            </div>
            <div className={classes.description}>
              Luxury Suites provide a private, upscale group entertainment
              option, featuring all-inclusive food & beverage. Click here to
              reserve your suite online!
            </div>
            <div
              className={classes.blueButton}
              onClick={() =>
                window.open(
                  "https://www.mlb.com/nationals/tickets/premium/luxury-suites#select-your-game",
                  "_blank",
                  "noopener,noreferrer"
                )
              }
            >
              Book Luxury Suite
            </div>
          </div>

          <div className={classes.premiumSales}>
            <div className={classes.smallTitle}>Interested in 50+ Seats?</div>
            <div className={classes.description}>
              The bigger your group, the bigger your savings! Click here to chat
              with a Nationals representative to book a group outing for 50 or
              more guests.
            </div>
            <a onClick={openChatPopUp} className={classes.blueButton}>
              Chat Now
            </a>
          </div>
        </div>
      </div>
      <FormController
        backTo="/ticket-single-group"
        nextTo="/ticket-single-group/ticket-single-group-checkout"
        startOver="/"
        submitText="Checkout"
        showBack={true}
        showStartOver={true}
        showSkip={false}
        showSubmit={true}
        disableSubmit={disableSubmit}
      />
    </div>
  );
};

export default GroupSelectYourSeat;
